import { ButtonsContainer } from './styles/ButtonContainer.styled';
import { UseFormReset } from 'react-hook-form';
import { IForm } from '../NewRequestPopUp';
import {
  SecondaryButton,
  PrimaryButton,
} from 'src/styles/globalStyles/buttonStyles.styled';

interface ButtonContainerProps {
  hidePopup: () => void;
  reset: UseFormReset<IForm>;
}

export const ButtonContainer = ({ hidePopup, reset }: ButtonContainerProps) => {
  return (
    <ButtonsContainer>
      <SecondaryButton
        id="close"
        appearance={'secondary'}
        onClick={() => {
          reset();
          hidePopup();
        }}
      >
        Discard
      </SecondaryButton>
      <PrimaryButton appearance={'primary'} type="submit">
        Submit
      </PrimaryButton>
    </ButtonsContainer>
  );
};
